import styled from "styled-components";

export const Toolbar = styled.div`
  display: flex;
  justify-content: end;
`;
